module.exports = __webpack_public_path__ + "static/media/karenPost.f41fc559.jpg";